import { z } from 'zod/v4'
import type { DeliveryRouteContactInput } from './delivery-route-contacts.types'

export const deliveryRouteContactFormSchema = z
  .object({
    name: z.string().trim().min(1, 'Name is required').max(255, 'Name is too long.'),
    email: z
      .string()
      .trim()
      // oxlint-disable-next-line typescript/no-deprecated -- grandfathered
      .email('Enter a valid email address.')
      .max(255, 'Email is too long.')
      .or(z.literal(''))
      .optional(),
    phone: z.string().trim().max(255, 'Phone number is too long.').optional(),
  })
  .refine((value) => Boolean(value.email?.trim() || value.phone?.trim()), {
    message: 'Add an email address or phone number.',
    path: ['email'],
  })

export type DeliveryRouteContactFormValues = z.infer<typeof deliveryRouteContactFormSchema>

/** Expects parsed form values: the schema's refinement guarantees an email or a phone. */
export function toDeliveryRouteContactPayload(
  value: DeliveryRouteContactFormValues
): DeliveryRouteContactInput {
  const name = value.name.trim()
  const email = value.email?.trim() || null
  const phone = value.phone?.trim() || null

  if (email) {
    return { name, email, phone }
  }

  if (phone) {
    return { name, email, phone }
  }

  throw new Error('Add an email address or phone number.')
}
